module.exports = __webpack_public_path__ + "static/media/casemanagers.5c6c002b.svg";